export const HUBSPOT_FORM_WINDOW_KEY = 'HubSpotFormsV4';